import { Lesson } from '../../../../types';

const lesson: Lesson = {
  itemId: '3893604',
  title: 'Me Siga nas Redes Sociais',
  video: { platform: 'youtube', videoId: 'KEqQKQJCrBY' },
  article: ['Descrição da aula.'],
};
export default lesson;

